export default defineNuxtPlugin(() => {
  // Only run on client side
  if (process.client) {
    // UTM parameter names to capture
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
    
    // Function to get UTM parameters from current URL
    const captureUtmParams = () => {
      const urlParams = new URLSearchParams(window.location.search)
      const utmData = {}
      
      utmParams.forEach(param => {
        const value = urlParams.get(param)
        if (value) {
          utmData[param] = value
        }
      })
      
      // Only store if we found UTM parameters
      if (Object.keys(utmData).length > 0) {
        sessionStorage.setItem('utm_params', JSON.stringify(utmData))
      }
    }
    
    // Function to retrieve UTM parameters from sessionStorage
    const getUtmParams = () => {
      try {
        const stored = sessionStorage.getItem('utm_params')
        return stored ? JSON.parse(stored) : {}
      } catch (error) {
        console.warn('Error retrieving UTM parameters:', error)
        return {}
      }
    }
    
    // Capture UTM parameters on plugin initialization
    captureUtmParams()
    
    // Make the retrieval function globally available
    return {
      provide: {
        getUtmParams
      }
    }
  }
})
